import { Component, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
    FEATURE_BILLING,
    hasFeatureFlag
} from '@flyfreely-portal-ui/flyfreely';
import { WorkspaceStateService } from '@flyfreely-portal-ui/workspace';

@Component({
    selector: 'upsell-button',
    templateUrl: './upsell-button.component.html',
    styleUrls: ['./upsell-button.component.scss']
})
export class UpsellButtonComponent {
    @Input()
    text: string;

    @Input()
    tooltipPlacement = 'top';

    @Input()
    buttonClasses: string;

    canViewBilling = false;

    constructor(workspaceStateService: WorkspaceStateService) {
        workspaceStateService.currentOrganisation$
            .pipe(takeUntilDestroyed())
            .subscribe(current => {
                if (current.type !== 'organisation_loaded') {
                    this.canViewBilling = false;
                    return;
                }

                this.canViewBilling = hasFeatureFlag(
                    current.organisation,
                    FEATURE_BILLING
                );
            });
    }
}
